import { makeStyles } from "@mui/styles";

import theme from "src/theme";
import { appColors } from "src/consts/app-config";
import {
    MAX_CHANGE_SCREEN_WIDTH,
} from "src/pages/game-new2/constants";

import { useBlockCommonStyles } from "../styles";

export const useStyles = makeStyles({
    "@global": {
        "@keyframes mobileNewGameOrFriendsAppear": {
            "0%": {
                opacity: 0,
                filter: "blur(5px)",
            },
            "100%": {
                opacity: 1,
                filter: "blur(0px)",
            },
        },
        "@keyframes fullGameCountBefore": {
            "0%": {
                opacity: 1,
                transform: "translate(-50%, -50%)",
            },
            "10%": {
                opacity: 1,
            },
            "40%": {
                opacity: 0,
            },
            "100%": {
                transform: "translate(-50%, -250%)",
                opacity: 0,
            },
        },
        "@keyframes fullGameCountAfter": {
            "0%": {
                opacity: 0,
                transform: "translate(-50%, -250%)",
            },
            "10%": {
                opacity: 0,
            },
            "40%": {
                opacity: 1,
            },
            "100%": {
                transform: "translate(-50%, -50%)",
                opacity: 0.9,
                color: appColors.txt950,
            },
        },
    },

    gameOrFriendscontainer: {
        dispaly: "none",
        [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
            height: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            alignSelf: "center",
            width: "100%",
            position: "relative",
            background: "rgba(18, 18, 18, 1)",
            animation: "mobileNewGameOrFriendsAppear",
            animationIterationCount: "1",
            animationFillMode: "forwards",
            animationDelay: "0.0s",
            animationDuration: "1100ms",
            padding: "0px",
            margin: "0px",
            "&::after": {
                content: '""',
                "-webkit-box-shadow":
                    "0px -11px 20px 0px rgba(195, 195, 195, 0.2)",
                "-moz-box-shadow":
                    "0px -11px 20px 0px rgba(195, 195, 195, 0.2)",
                boxShadow: "0px -11px 20px 0px rgba(195, 195, 195, 0.2)",
                width: "100%",
                height: "100%",
                display: "block",
                position: "absolute",
                top: 0,
                zIndex: -1,
            },
        },
    },   

    mobileGameBlocks: (props: {
        contentTextBefore: string | undefined;
        contentTextAfter: string | undefined;
    }) => ({
        [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "fit-content",
            height: "50px",
            alignSelf: "center",
            cursor: "pointer",
            "&.middleIcon": {
                width: "80px",
                height: "80px",
                borderRadius: "50%",
            },
            "&.middleText": {
                width: "60px",
                height: "fit-content",
                margin: 0,
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1,
                color: appColors.white,
                fontWeight: 700,
                textAlign: "center",
            },
            "&.toGame": {
                fontSize: "13px",
            },
            "&.icon": {
                margin: 0,
                height: "24px",
                aspectRatio: 1 / 1,
            },
            "&.profile": {
                filter: "brightness(0.6)",
            },
            "&.text": {
                fontSize: "12px",
                fontFamily: "Montserrat",
                margin: 0,
                display: "flex",
                flexDirection: "column",
                height: 18,
                fontWeight: 500,
                color: "rgba(245, 245, 245, 0.6)",
            },
            "&.fullBeforeGameCount": {
                opacity: 1,
                color: appColors.white,
                "&:before": {
                    display: "block",
                    content: `"${props.contentTextBefore}"`,
                    opacity: 1,
                    position: "absolute",
                    zIndex: 1,
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                },
                "&:after": {
                    display: "none",
                    content: `""`,
                    opacity: 0,
                    position: "absolute",
                    zIndex: 1,
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -200%)",
                },
            },
            "&.fullAfterGameCount": {
                opacity: 1,
                color: appColors.white,
                "&:before": {
                    display: "block",
                    animationName: "fullGameCountBefore",
                    animationIterationCount: "1",
                    animationFillMode: "forwards",
                    animationDuration: "500ms",
                    animationDelay: "1.2s",
                    content: `"${props.contentTextBefore}"`,
                    opacity: 1,
                    position: "absolute",
                    zIndex: 1,
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                },
                "&:after": {
                    display: "block",
                    animationName: "fullGameCountAfter",
                    animationIterationCount: "1",
                    animationFillMode: "forwards",
                    animationDuration: "500ms",
                    animationDelay: "1.5s",
                    content: `"${props.contentTextAfter}"`,
                    opacity: 0,
                    position: "absolute",
                    zIndex: 1,
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -200%)",
                },
            },
            "&.createBtnDisabled": {
                fontSize: "14px",
                fontWeight: 500,
            },
        },
    }),


    iconWrapper: {
        position: "relative",
        display: "flex",
        justifyContent: 'center',
    },
    friendRequestIndicator: {
        position: "absolute",
        top: "-4px",
        right: "-4px",
        width: "8px",
        height: "8px",
        backgroundColor: "#00BA6C", 
        borderRadius: "50%",
        border: "1px solid #1E1F23", 
        zIndex: 1,
        boxShadow: "0 0 0 rgba(0, 186, 108, 0.4)",
        animation: "$pulse 3s ease-in-out infinite",
        transform: "scale(1)",
    },
    "@keyframes pulse": {
        "0%": {
            transform: "scale(0.95)",
            boxShadow: "0 0 0 0 rgba(0, 186, 108, 0.6)",
        },
        "50%": {
            transform: "scale(1.1)",
            boxShadow: "0 0 0 8px rgba(0, 186, 108, 0)",
        },
        "100%": {
            transform: "scale(0.95)",
            boxShadow: "0 0 0 0 rgba(0, 186, 108, 0)",
        }
    },

    gameOrFriendsContainerBox: {
        width: "100%",
        height: "100%",
        position: "relative",
        display: "flex",
        justifyContent: "space-evenly",
        boxShadow: "0px 0px 40px 10px #131525",       
    },

    startLobbyUserButtons: {
        display: "none",
        '&.disabled': {
          opacity: 0.4
        },
        [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "33%",
            "&.betAndTime": {
                width: "33%",
            },
            "&.middle": {
                position: "relative",
                minWidth: 90,
                width: "20%",
            },
        },
    },

    createGameBoxItemHideImg: {
        [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
            position: "absolute",
            top: "5px",
            right: "5px",
        },
    },

    title: useBlockCommonStyles.title,
    wrapper: {
        display: "grid",
        gridTemplateColumns: "auto auto auto auto",
        alignItems: "center",
        gridColumnGap: "16px",
        "@media screen and (max-width: 1380px)": {
            gridColumnGap: "8px",
        },
        "@media screen and (max-width: 1100px)": {
            gridColumnGap: "15px",
        },
        [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
            display: "grid",
            height: "auto",
            position: "static",
            minWidth: "auto",
            width: "100%",
            gridTemplateColumns: "1fr 1fr",
            gridRowGap: "12px",
            gridColumnGap: "18px",
            padding: "0 40px",
        },
        "@media screen and (max-width: 620px)": {
            padding: "0 25px",
        },
        "@media screen and (max-width: 475px)": {
            padding: "0",
        },
    },
    createGameBoxItemTime: {
        ...useBlockCommonStyles.createGameBoxItemTime,
        [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
            position: "static",
            display: "flex",
            justifyContent: "center",
            width: "100%",
        },
    },
    createGameBoxItemBet: {
        ...useBlockCommonStyles.createGameBoxItemBet,
        [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
            display: "flex",
            justifyContent: "flex-start",
            width: "100%",
        },
    },

    configWrapper: {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
    },
    closeIcon: {
        zIndex: 2,
    },
    buttonWrapper: {
        maxWidth: 400,
        width: "auto",
        height: "100%",
        display: "flex",
        justifySelf: "center",
        aspectRatio: 1 / 1,
        borderRadius: "50%",
        position: "relative",
        justifyContent: "center",
        alignItems: "center",
    },

    openCreateIcon: {
        height: "84%",
        "&.createBtnDisabled": {
            filter: "brightness(30%)",
        },
    },

    button: {
        "& .steel-wrapper": {
            width: "100%",
        },
        "& .black-wrapper": {
            width: "100%",
        },
        "& .button": {
            padding: "9px 25px",
            [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
                width: "100%",
            },
        },
        "& .text": {
            fontSize: 16,
        },
        [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
            width: "100%",
        },
    },
    createGameButton: {
        "& .button": {
            padding: "8px 26px",
            [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
                width: "100%",
            },
        },
    },
    quickButton: {
        "& .button": {
            padding: "8px 24px",
            [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
                width: "100%",
            },
        },
    },

    cross: {
        [theme.breakpoints.down(MAX_CHANGE_SCREEN_WIDTH)]: {
            width: 20,
            height: 20,
            position: "relative",
            opacity: 0.8,
            "&::before": {
                content: '""',
                display: "block",
                width: "110%",
                height: "2px",
                position: "absolute",
                top: "50%",
                left: "50%",
                "-webkit-transform": "translate(-50%,-50%) rotate(45deg)",
                transform: "translate(-50%,-50%) rotate(45deg)",
                backgroundColor: appColors.white,
                boxShadow: `1px 1px 9px ${appColors.semiwhite}`,
            },
            "&::after": {
                content: '""',
                display: "block",
                width: "110%",
                height: "2px",
                position: "absolute",
                top: "50%",
                left: "50%",
                "-webkit-transform": "translate(-50%,-50%) rotate(-45deg)",
                transform: "translate(-50%,-50%) rotate(-45deg)",
                backgroundColor: appColors.white,
                boxShadow: `1px 1px 9px ${appColors.semiwhite}`,
            },
        },
    },
});
